module.exports = {
      id: "logo-usage",
      viewBox: "0 0 33 38",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#logo",
      toString: function () {
        return this.url;
      }
    }